import type { Config } from '@gmn-portal/backend';

import { PayloadApiClient } from './client';

const payloadClient = new PayloadApiClient<Config>({
  apiURL: import.meta.env.VITE_BACKEND_URL || 'http://localhost:3000/api',
  fetcher: (url, init) => {
    return fetch(url, {
      ...(init ?? {}),
    });
  },
});

export { payloadClient };
export * from './auth';
export * from './client';
export * from './contract-files';
export * from './contracts';
export * from './customers';
export * from './entity-permissions';
export * from './global-metadata';
export * from './invites';
export * from './media';
export * from './notifications';
export * from './object-categories';
export * from './object-photos';
export * from './objects';
export * from './operation-files';
export * from './operations';
export * from './system-ships';
export type * from './types';
export * from './user-groups';
export * from './users';
